export default "__VITE_ASSET__CTRG5pGp__"